<template>
<div class="apprentice-simple-card">
    Type:
    <span v-if="projectIn.group.editor_type === 'oo'">Only Office</span>
    <span v-if="projectIn.group.editor_type === 'moo'">Microsoft Online</span>
    <span v-if="projectIn.group.editor_type === 'sp'">Sharepoint (office 365)</span>
    <span v-if="projectIn.group.editor_type === 'gd'">Google Drive</span>
</div>
</template>

<script>
export default {
    name: "design-2021-project-show-admin-editor-component",
    props: ['projectIn']
}
</script>

<style scoped>

</style>
